<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">Tambah Slider</h2>


    <v-form ref="formAddProduct" role="form">
      <v-card outlined class="px-3 py-3 my-5" v-if="$route.name == 'seller-slider-tambah'">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">
          Upload Gambar
          <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
        </v-card-title>
        <v-card-text class="px-2">
          <div class="text-caption">
            Format gambar jpg, jpeg, png, webp. Maksimal ukuran file 2MB.
          </div>
          <div class="text-center mt-3" v-if="image_alert">
            <v-alert class="white--text red lighten-1" dense dismissible @input="toggleAlert"
              v-model="image_alert">Harus disertai gambar</v-alert>
          </div>

          <v-row class="my-5 d-flex align-center justify-center flex-row">
            <v-col cols="4" sm="2" v-for="(img, idg) in imgProduct" :key="idg">
              <div class="product-img d-row outlined py-4 px-4" :class="img ? '' : 'emptyImg'">
                <v-img width="100%" :src="img ? img : '/assets/seller/add-image-icon.svg'"></v-img>
                <v-btn v-if="img" class="mx-0 close-btn" fab dark x-small color="red" @click="removeImage(idg)">
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <div v-show="false">
            <v-file-input @change="createImage($event)" id="inputProdukImg" ref="fileupload" chips accept="image/*"
              multiple small-chips prepend-icon truncate-length="50"></v-file-input>
          </div>
          <div class="v-row d-flex flex-column align-center">
            <v-btn color="black" elevation="2" dark min-width="140" class="my-3" @click="openUpload">
              <strong class="text-capitalize text-subtitle-2 font-weight-bold">
                <v-icon color="white darken-1 mr-2">mdi-plus</v-icon>Pilih Gambar
              </strong>
            </v-btn>

            <!-- <v-btn
              color="warning"
              elevation="2"
              dark
              min-width="140"
              class="my-3"
              v-else
            >
              <strong class="text-capitalize text-subtitle-2 font-weight-bold"><v-icon color="white darken-1 mr-2">mdi-upload</v-icon> Upload Produk</strong>
            </v-btn>-->
            <!-- <div class="text-caption font-weight-bold">Letakkan hingga 5 gambar sekaligus disini.</div> -->
          </div>
        </v-card-text>
      </v-card>

      <v-card outlined class="px-3 py-3 my-5">
        <v-card-title class="pt-0 px-2 text-subtitle-1 font-weight-bold black--text darken-4">Informasi
          Slider</v-card-title>
        <v-card-text class="px-2">
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Judul
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-text-field :rules="nameRules" v-model="produkInput.nama" outlined small dense counter="70"
                placeholder="Masukkan nama produk" :error-messages="responseError.name"
                @focus="() => (responseError.name = '')"></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">
                Link
                <v-icon size="10" color="red" class="pb-4">mdi-asterisk</v-icon>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="pb0-xs">
              <v-text-field :rules="linkRules" v-model="produkInput.link" outlined small dense counter="70"
                placeholder="Masukkan link" :error-messages="responseError.link"
                @focus="() => (responseError.link = '')"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" class="pb0-xs">
              <div class="d-block text-subtitle-2 font-weight-bold black--text">Status</div>
            </v-col>
            <v-col cols="12" sm="2" class="pb0-xs">
              <v-switch v-model="produkInput.status" class="my-0 py-0" inset hide-details="auto" true-value="active"
                false-value="inactive" dense></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>

    <v-layout v-resize="onResize" column>
      <v-card outlined class="px-3 py-3 my-5">
        <v-card-text>
          <v-row>
            <v-col cols="12" class="text-right py-0 px-0">
              <v-btn color="error" dark text min-width="140" :loading="loadingProcess" class="mr-2" v-if="!isMobile"
                @click="cancelForm">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>

              <v-btn color="black" elevation="2" outlined dark min-width="140" :loading="loadingProcess"
                :class="isMobile ? 'v-btn--block mb-3' : 'mr-2'" @click="save(1)" v-if="!isMobile">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan &amp; Tambah Baru</strong>
              </v-btn>

              <v-btn color="black" elevation="2" dark min-width="140" :loading="loadingProcess"
                :class="isMobile ? 'v-btn--block mb-3' : ''" @click="save(2)">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan</strong>
              </v-btn>

              <v-btn color="black" elevation="2" outlined dark :class="isMobile ? 'v-btn--block mb-3' : 'mr-2'"
                min-width="140" :loading="loadingProcess" @click="save(1)" v-if="isMobile">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Simpan &amp; Tambah Baru</strong>
              </v-btn>

              <v-btn color="error" elevation="2" outlined dark min-width="140" :loading="loadingProcess"
                :class="isMobile ? 'v-btn--block mb-3' : 'mr-2'" v-if="isMobile" @click="cancelForm">
                <strong class="text-capitalize text-subtitle-2 font-weight-bold">Batal</strong>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
const defaultInput = () => ({
  nama: "",
  link: "",
  slug: "",
  status: "active",
  image: [],
  isMobile: false,
});
export default {
  data() {
    return {
      title: "",
      image_alert: false,
      isMobile: false,
      loadingProcess: false,
      nameRules: [
        v => !!v || "Judul tidak boleh kosong",
        v => v.length >= 1 || "Judul minimal 1 karakter"
      ],
      linkRules: [
        v => !!v || "Link tidak boleh kosong",
        // v => v.length >= 1 || "Link minimal 1 karakter"
      ],
      imgPreview: [],
      produkInput: defaultInput(),
    };
  },

  computed: {
    ...mapState("sliderSeller", ["responseError", "detailSlider"]),
    ...mapState("storeSeller", ["detailStore"]),

    imgProduct() {
      let img = [];
      for (var i = 0; i < 1; i++) {
        img[i] = this.imgPreview[i] ? this.imgPreview[i].img : undefined;
      }
      return img;
    }
  },

  methods: {
    ...mapActions("sliderSeller", [
      "addSlider",
      "uploadImage",
      "getSliderDetail"
    ]),
    ...mapMutations("sliderSeller", ["clearSlider"]),
    ...mapMutations(["makeAlert"]),
    ...mapActions("storeSeller", ["getStoreDetail"]),
    removeImage(index) {
      this.imgPreview.splice(index, 1);
    },
    async openUpload() {
      const input = await document.getElementById("inputProdukImg");
      input.click();
    },
    createImage(event) {
      var dimensions = [];
      event.forEach(el => {
        dimensions.push(
          new Promise(function (resolve) {
            var reader = new FileReader();
            reader.onload = e => {
              resolve({
                img: e.target.result,
                file: el
              });
            };
            reader.readAsDataURL(el);
          })
        );
      });

      Promise.all(dimensions)
        .then(res => {
          if (this.imgPreview.length + res.length > 1)
            this.makeAlert({
              code: "error_response",
              type: "error",
              message: "Gambar maksimal 1",
              show: true
            });

          res.splice(5 - this.imgPreview.length, res.length - 1);
          this.imgPreview = [...this.imgPreview, ...res];

          if (this.imgPreview.length > 0) this.image_alert = false;
        })
        .catch(function (err) {
          this.makeAlert({
            code: "error_response",
            type: "error",
            message: "Error",
            show: true
          });
          this.loadingProcess = false;
          console.log(err);
        });
    },
    upload(type) {
      var dimensions = [];
      this.imgPreview.forEach(el => {
        dimensions.push(
          new Promise(resolve => {
            let formData = new FormData();
            formData.append("image", el.file);
            this.uploadImage(formData)
              .then(res => {
                resolve(res.slider_image);
              })
              .catch(err => {
                this.loadingProcess = false;
              });
          })
        );
      });

      Promise.all(dimensions)
        .then(dims => {
          this.produkInput.image = dims;
          let resetSlider = type => {
            this.$refs.formAddProduct.resetValidation();
            this.$refs.fileupload.clearableCallback();
            this.imgPreview = [];
            this.produkInput = defaultInput();
            this.loadingProcess = false;
            if (type === 2) this.$router.push("/seller/slider/data");
          };
          if (this.detailStore.store_is_b2b == "false") {
            let params = {
              name: this.produkInput.nama,
              link: this.produkInput.link,
              status: this.produkInput.status,
              image: this.produkInput.image,
            };
            this.addSlider(params)
              .then(() => {
                resetSlider(type);
              })
              .catch(() => {
                this.loadingProcess = false;
              });
          }
        })
        .catch(function (err) {
          console.log(err);
          this.loadingProcess = false;
        });
    },
    async save(type) {
      if (this.$refs.formAddProduct.validate()) {
        this.loadingProcess = await true;
        if (this.imgPreview.length > 0) {
          this.image_alert = false;
          await this.upload(type);
        } else {
          this.image_alert = true;
          this.loadingProcess = false;
        }
      }
    },
    cancelForm() {
      this.$router.push("/seller/slider/data");
    },
    toggleAlert(val) {
      this.image_alert = val;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },
  created() {
    this.$store.dispatch("setPageTitle", `Tambah Slider`);
    this.getStoreDetail();
    // this.getCategory();
  },
  beforeDestroy() {
    this.clearProduct();
  }
};
</script>

<style lang="scss" scoped>
.product-img {
  border: 2px solid green;
  border-radius: 4px;

  &.emptyImg {
    border: 2px solid #ddd;
  }
}

.product-img {
  position: relative;

  .close-btn {
    position: absolute;
    top: -15px;
    right: -15px;
    height: 28px;
    width: 28px;
  }
}
</style>
